<template>
  <div>
    <div>
      <el-form ref="form">
        <el-space wrap>
          <!-- <el-form-item label="共振趋势:">
            <el-select v-model="obj.trend" @change="handleSelectChange" style="width:110px">
              <el-option v-for="item in obj.trendList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="长期短期级别:">
            <el-select v-model="obj.interval" @change="handleSelectChange" style="width:130px">
              <el-option v-for="item in obj.interval_List" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="">
            <el-button type="primary" @click="handleSubmit">
              <el-icon class="el-input__icon">
                <cpu />
              </el-icon>筛选
            </el-button>
          </el-form-item> -->
          <el-form-item label="">
            <el-button type="primary" @click="handleRefresh">
              <el-icon class="el-input__icon">
                <refresh />
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </el-form>
    </div>
    <div>
      <el-tag type="warning" size="small" v-if="obj.date !== ''">更新日： {{ obj.date }}</el-tag>
    </div>
    <div>
      <el-tag type="warning" size="small">大盘</el-tag>
    </div>
    <div>
      <el-table :data="obj.dataList_0" height="100%" style="width: 100%" empty-text=" " :style="'height:' + 100 + 'px'"
        :cell-style="cellStyle">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="110px" align="right" sortable />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
        <el-table-column label="收盘" prop="close" width="80px" align="right" />
        <el-table-column label="涨幅%" prop="chg2Pct" align="right" width="100px" :sort-method="customPctSort" sortable />
        <el-table-column label="长期" prop="trend_1" width="80px" align="right" />
        <el-table-column label="已持续" prop="duration_data_1" width="80px" align="right" />
        <el-table-column label="总涨幅" prop="acc_chg_pct_1" width="90px" align="right" :sort-method="customPctSort2"
          sortable />
        <el-table-column label="趋势度" prop="acc_trend_1" width="90px" align="right" sortable />
        <el-table-column label="最新反转信号" prop="reverse_1" width="120px" align="right" />
        <el-table-column label="最新背离信号" prop="divergence_1" width="120px" align="right" />
        <el-table-column label="最新减仓信号" prop="reduce_1" width="120px" align="right" />
        <el-table-column label="短期" prop="trend_2" width="80px" align="right" />
        <el-table-column label="已持续" prop="duration_data_2" width="80px" align="right" />
        <el-table-column label="总涨幅" prop="acc_chg_pct_2" width="90px" align="right" :sort-method="customPctSort3"
          sortable />
        <el-table-column label="趋势度" prop="acc_trend_2" width="90px" align="right" sortable />
        <el-table-column label="最新反转信号" prop="reverse_2" width="120px" align="right" />
        <el-table-column label="最新背离信号" prop="divergence_2" width="120px" align="right" />
        <el-table-column label="最新减仓信号" prop="reduce_2" width="120px" align="right" />
        <el-table-column label="操作建议" prop="strategy" width="120px" align="right" />
      </el-table>
    </div>
    <el-tag type="warning" size="small">板块</el-tag>
    <div>
      <el-table :data="obj.dataList" height="100%" style="width: 100%" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 350) / 2 + 'px'" :cell-style="cellStyle"
        @row-click="handleRowClick" highlight-current-row ref="singleTableRef">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="110px" align="right" sortable />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
        <el-table-column label="收盘" prop="close" width="80px" align="right" />
        <el-table-column label="涨幅%" prop="chg2Pct" align="right" width="100px" :sort-method="customPctSort" sortable />
        <el-table-column label="长期" prop="trend_1" width="80px" align="right" />
        <el-table-column label="已持续" prop="duration_data_1" width="80px" align="right" />
        <el-table-column label="总涨幅" prop="acc_chg_pct_1" width="90px" align="right" :sort-method="customPctSort2"
          sortable />
        <el-table-column label="趋势度" prop="acc_trend_1" width="90px" align="right" sortable />
        <el-table-column label="最新反转信号" prop="reverse_1" width="120px" align="right" />
        <el-table-column label="最新背离信号" prop="divergence_1" width="120px" align="right" />
        <el-table-column label="最新减仓信号" prop="reduce_1" width="120px" align="right" />
        <el-table-column label="短期" prop="trend_2" width="80px" align="right" />
        <el-table-column label="已持续" prop="duration_data_2" width="80px" align="right" />
        <el-table-column label="总涨幅" prop="acc_chg_pct_2" width="90px" align="right" :sort-method="customPctSort3"
          sortable />
        <el-table-column label="趋势度" prop="acc_trend_2" width="90px" align="right" sortable />
        <el-table-column label="最新反转信号" prop="reverse_2" width="120px" align="right" />
        <el-table-column label="最新背离信号" prop="divergence_2" width="120px" align="right" />
        <el-table-column label="最新减仓信号" prop="reduce_2" width="120px" align="right" />
        <el-table-column label="操作建议" prop="strategy" width="120px" align="right" />
      </el-table>
    </div>
    <div>
      <el-space wrap>
        <el-tag type="warning" size="small">合约</el-tag>
        <el-tag type="danger" size="small" v-if="obj.selectedBlock !== ''">{{ obj.selectedBlock }}</el-tag>
      </el-space>
    </div>
    <div>
      <el-table :data="obj.dataList_2" height="100%" style="width: 100%" empty-text=" "
        :style="'height:' + (this.$store.state.windowHeight - 350) / 2 + 'px'" :cell-style="cellStyle"
        @row-click="handleRowClick2">
        <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
        <el-table-column fixed label="名称" prop="name" width="110px" align="right" sortable />
        <el-table-column label="代码" prop="symbol" width="100px" align="right" sortable />
        <el-table-column label="收盘" prop="close" width="80px" align="right" />
        <el-table-column label="涨幅%" prop="chg2Pct" align="right" width="100px" :sort-method="customPctSort" sortable />
        <el-table-column label="长期" prop="trend_1" width="80px" align="right" />
        <el-table-column label="已持续" prop="duration_data_1" width="80px" align="right" />
        <el-table-column label="总涨幅" prop="acc_chg_pct_1" width="90px" align="right" :sort-method="customPctSort2"
          sortable />
        <el-table-column label="趋势度" prop="acc_trend_1" width="90px" align="right" sortable />
        <el-table-column label="最新反转信号" prop="reverse_1" width="120px" align="right" />
        <el-table-column label="最新背离信号" prop="divergence_1" width="120px" align="right" />
        <el-table-column label="最新减仓信号" prop="reduce_1" width="120px" align="right" />
        <el-table-column label="短期" prop="trend_2" width="80px" align="right" />
        <el-table-column label="已持续" prop="duration_data_2" width="80px" align="right" />
        <el-table-column label="总涨幅" prop="acc_chg_pct_2" width="90px" align="right" :sort-method="customPctSort3"
          sortable />
        <el-table-column label="趋势度" prop="acc_trend_2" width="90px" align="right" sortable />
        <el-table-column label="最新反转信号" prop="reverse_2" width="120px" align="right" />
        <el-table-column label="最新背离信号" prop="divergence_2" width="120px" align="right" />
        <el-table-column label="最新减仓信号" prop="reduce_2" width="120px" align="right" />
        <el-table-column label="操作建议" prop="strategy" width="120px" align="right" />
      </el-table>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { http } from '../util/http'
import { ElMessage } from 'element-plus'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const singleTableRef = ref()
    const chartDomRef = ref()
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      trendList: [
        {
          value: 'Long',
          label: '多头'
        },
        {
          value: 'Short',
          label: '空头'
        },
      ],
      trend: 'Long',
      interval_List: [
        {
          value: 'w',
          label: '周线 日线'
        },
        {
          value: 'd',
          label: '日线 1小时线'
        },
      ],
      interval: 'w',
      dataList_0: [],
      dataList: [],
      dataList_2: [],
      date: '',
      selectedBlock: '',
      selectedBlockValue: '',
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.strategyData === '') {
        // 无缓存，从后台请求数据
        requestData0()
        requestData()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 后台获取数据
    const requestData0 = () => {
      let formData = new FormData()
      // formData.append("trend", obj.trend)
      formData.append("interval", obj.interval)
      formData.append("block", "idx")
      http({
        url: `/trend`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有查询到大盘数据')
        }
        obj.dataList_0 = processData(res.data.data)
        setStore()
      })
    }


    // 后台获取数据
    const requestData = () => {
      let formData = new FormData()
      // formData.append("trend", obj.trend)
      formData.append("interval", obj.interval)
      formData.append("block", "all")
      http({
        url: `/trend`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有符合条件的数据')
        }
        obj.dataList = processData(res.data.data)
        setStore()
      })
    }

    // const setCurrent = (row) => {
    //   singleTableRef.value.setCurrentRow(row)
    // }

    // 后台获取数据2
    const requestData2 = (symbol) => {
      let formData = new FormData()
      // formData.append("trend", obj.trend)
      formData.append("interval", obj.interval)
      formData.append("block", symbol)
      http({
        url: `/trend`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        if (res.data.data.length === 0) {
          ElMessage.info('没有符合条件的合约')
        }
        obj.dataList_2 = processData(res.data.data)
        setStore()
      })
    }

    // 处理数据
    const processData = (data) => {
      let no = 1
      data.forEach((item) => {
        obj.date = item.date
        if (item.chg2Pct !== "-") {
          item.chg2Pct = parseFloat(item.chg2Pct * 100).toFixed(2) + '%'
          if (item.acc_chg_pct_1 !== "-") {
            item.acc_chg_pct_1 = parseFloat(item.acc_chg_pct_1 * 100).toFixed(2) + '%'
          }
          if (item.acc_trend_1 !== "-") {
            item.acc_trend_1 = parseFloat(item.acc_trend_1).toFixed(2)
          }
          if (item.acc_chg_pct_2 !== "-") {
            item.acc_chg_pct_2 = parseFloat(item.acc_chg_pct_2 * 100).toFixed(2) + '%'
          }
          if (item.acc_trend_2 !== "-") {
            item.acc_trend_2 = parseFloat(item.acc_trend_2).toFixed(2)
          }

          if (item.trend_1 == "up") {
            item.trend_1 = "多头"
          } else if (item.trend_1 == "down") {
            item.trend_1 = "空头"
          } else if (item.trend_1 == "sideways") {
            item.trend_1 = "震荡"
          }

          if (item.trend_2 == "up") {
            item.trend_2 = "多头"
          } else if (item.trend_2 == "down") {
            item.trend_2 = "空头"
          } else if (item.trend_2 == "sideways") {
            item.trend_2 = "震荡"
          }

          if (item.strategy == 0) {
            item.strategy = "观望"
          } else if (item.strategy == 1) {
            item.strategy = "多开"
          } else if (item.strategy == -1) {
            item.strategy = "空开"
          } else if (item.strategy == 2) {
            item.strategy = "轻仓试多"
          } else if (item.strategy == -2) {
            item.strategy = "轻仓试空"
          } else if (item.strategy == 3) {
            item.strategy = "多头减仓"
          } else if (item.strategy == -3) {
            item.strategy = "空头减仓"
          }
        }
        item.no = no
        no++
      })
      return data
    }

    // 保存Store
    const setStore = () => {
      var storeObj = {
        'trend': obj.trend,
        'interval': obj.interval,
        'dataList_0': obj.dataList_0,
        'dataList': obj.dataList,
        'dataList_2': obj.dataList_2,
        'date': obj.date,
        'selectedBlock': obj.selectedBlock,
        'selectedBlockValue': obj.selectedBlockValue
      }
      store.commit('setStrategyData', storeObj)
    }

    // 获取Store
    const getStore = () => {
      obj.trend = store.state.strategyData.trend
      obj.interval = store.state.strategyData.interval
      obj.date = store.state.strategyData.date
      obj.dataList_0 = store.state.strategyData.dataList_0
      obj.dataList = store.state.strategyData.dataList
      obj.dataList_2 = store.state.strategyData.dataList_2
      obj.selectedBlock = store.state.strategyData.selectedBlock
      obj.selectedBlockValue = store.state.strategyData.selectedBlockValue
    }

    // 重置画面
    const resetView = () => {
      obj.trend = 'Long'
      obj.interval = 'w'
      obj.date = ''
      obj.dataList_0 = []
      obj.dataList_0 = ''
      obj.dataList = []
      obj.dataList = ''
      obj.dataList_2 = []
      obj.dataList_2 = ''
      obj.selectedBlock = ''
      obj.selectedBlockValue = ''
    }

    /**
     * 事件处理区域
     */

    // 下拉框选择事件
    const handleSelectChange = (e) => {
      obj.selectedBlock = ""
      obj.selectedBlockValue = ""
      obj.dataList_2 = []
      requestData0()
      requestData()
    }

    // 按钮刷新事件
    const handleRefresh = (e) => {
      obj.selectedBlock = ""
      obj.selectedBlockValue = ""
      obj.dataList_2 = []
      requestData0()
      requestData()
    }

    // 表格行点击事件
    const handleRowClick = (row) => {
      obj.selectedBlock = row.name
      obj.selectedBlockValue = row.symbol
      let symbol = row.symbol
      requestData2(symbol)
    }

    // 表格行点击事件2
    const handleRowClick2 = (row) => {
      let name = row.name
      store.commit('setCurrentContract', name)
      router.push(`/candlestick?name=${name}`)
    }

    // 按钮提交事件
    const handleSubmit = () => {
      // if (!formCheck()) {
      //   return
      // }
      obj.selectedBlock = ""
      obj.selectedBlockValue = ""
      obj.dataList_2 = []
      requestData0()
      requestData()
    }

    // 表单Check处理
    const formCheck = () => {
      if (obj.indicators.trim() === '' && obj.patterns.trim() === '' &&
        (obj.customize.trim() === '' || obj.symbols.trim() === '')) {
        ElMessage.error('请选择或输入条件')
        return false
      }
      return true
    }

    /**
     * 样式设置区域
     */

    // 表格单元格样式
    const cellStyle = (row, column, rowIndex, columnIndex) => {
      if (row.row.chg2Pct.toString().replace('%', '') > 0 && row.columnIndex === 4) {
        return { color: 'red' }
      } else if (row.row.chg2Pct.toString().replace('%', '') < 0 && row.columnIndex === 4) {
        return { color: 'green' }
      }

      if (row.row.trend_1 == "多头" && row.columnIndex === 5) {
        return { color: 'red' }
      } else if (row.row.trend_1 == "空头" && row.columnIndex === 5) {
        return { color: 'green' }
      }
      if (row.row.acc_chg_pct_1.toString().replace('%', '') > 0 && row.columnIndex === 7) {
        return { color: 'red' }
      } else if (row.row.acc_chg_pct_1.toString().replace('%', '') < 0 && row.columnIndex === 7) {
        return { color: 'green' }
      }
      if (row.row.acc_trend_1 > 0 && row.columnIndex === 8) {
        return { color: 'red' }
      } else if (row.row.acc_trend_1 < 0 && row.columnIndex === 8) {
        return { color: 'green' }
      }
      if (row.row.reverse_1 !== "-" && row.row.reverse_1 !== "无" && row.columnIndex === 9) {
        return { color: 'orange' }
      }
      if (row.row.divergence_1 !== "-" && row.row.divergence_1 !== "无" && row.columnIndex === 10) {
        return { color: 'orange' }
      }
      if (row.row.reduce_1 !== "-" && row.row.reduce_1 !== "无" && row.columnIndex === 11) {
        return { color: 'orange' }
      }

      if (row.row.trend_2 == "多头" && row.columnIndex === 12) {
        return { color: 'red' }
      } else if (row.row.trend_2 == "空头" && row.columnIndex === 12) {
        return { color: 'green' }
      }
      if (row.row.acc_chg_pct_2.toString().replace('%', '') > 0 && row.columnIndex === 14) {
        return { color: 'red' }
      } else if (row.row.acc_chg_pct_2.toString().replace('%', '') < 0 && row.columnIndex === 14) {
        return { color: 'green' }
      }
      if (row.row.acc_trend_2 > 0 && row.columnIndex === 15) {
        return { color: 'red' }
      } else if (row.row.acc_trend_2 < 0 && row.columnIndex === 15) {
        return { color: 'green' }
      }
      if (row.row.reverse_2 !== "-" && row.row.reverse_2 !== "无" && row.columnIndex === 16) {
        return { color: 'orange' }
      }
      if (row.row.divergence_2 !== "-" && row.row.divergence_2 !== "无" && row.columnIndex === 17) {
        return { color: 'orange' }
      }
      if (row.row.reduce_2 !== "-" && row.row.reduce_2 !== "无" && row.columnIndex === 18) {
        return { color: 'orange' }
      }
    }

    // 表格排序(带百分号的数字列)
    const customPctSort = (a, b) => {
      return parseFloat(a.chg2Pct.replace('%', '')) - parseFloat(b.chg2Pct.replace('%', ''))
    }

    // 表格排序2(带百分号的数字列)
    const customPctSort2 = (a, b) => {
      return parseFloat(a.acc_chg_pct_1.replace('%', '')) - parseFloat(b.acc_chg_pct_1.replace('%', ''))
    }

    // 表格排序3(带百分号的数字列)
    const customPctSort3 = (a, b) => {
      return parseFloat(a.acc_chg_pct_2.replace('%', '')) - parseFloat(b.acc_chg_pct_2.replace('%', ''))
    }

    return {
      obj,
      chartDomRef,
      store,
      handleSelectChange,
      handleRefresh,
      handleRowClick,
      handleRowClick2,
      handleSubmit,
      cellStyle,
      customPctSort,
      customPctSort2,
      customPctSort3
    }
  }
}
</script>
<style lang="scss" scoped></style>
